import _extends from "/data/wwwroot/dongliyuanlin.com/web/node_modules/babel-runtime/helpers/extends";
import _regeneratorRuntime from "/data/wwwroot/dongliyuanlin.com/web/node_modules/babel-runtime/regenerator";
import _asyncToGenerator from "/data/wwwroot/dongliyuanlin.com/web/node_modules/babel-runtime/helpers/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CommonContent from "~/components/CommonContent";
import PageTitle from "~/components/PageTitle";

import { mapState } from "vuex";
export default {
  data: function data() {
    return {
      idx: 0,
      res: null

    };
  },

  components: {
    CommonContent: CommonContent,
    PageTitle: PageTitle
  },
  asyncData: function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var store = _ref.store,
          query = _ref.query;
      var result;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return store.dispatch("getPageData", { id: "7", lang: query.lang });

            case 2:
              result = _context.sent;
              return _context.abrupt("return", { pageData: result });

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function asyncData(_x) {
      return _ref2.apply(this, arguments);
    }

    return asyncData;
  }(),

  methods: {
    toggle: function toggle(index) {
      var _this = this;

      this.idx = index;
      this.res = this.pageData.filter(function (val) {
        return val.title === _this.classList[_this.idx].name;
      });
    }
  },
  computed: _extends({}, mapState(["winHeight", 'lang']), {
    up: function up() {
      return {
        height: this.winHeight - 60 + "px"
      };
    },
    pro: function pro() {
      if (this.lang === 'en') {
        return 'Engineering Technology';
      } else {
        return '工程工艺';
      }
    },
    classList: function classList() {
      var arr = this.pageData.map(function (val) {
        return { name: val.title };
      });
      return arr.reverse();
    }
    // res() {
    //   return this.pageData.filter(val => val.title === this.classList[this.idx].name)
    // }

  }),
  created: function created() {
    var _this2 = this;

    // $.fn.fullpage.destroy()
    this.idx = this.$route.query.index;
    this.res = this.pageData.filter(function (val) {
      return val.title === _this2.classList[_this2.idx].name;
    });
  },
  mounted: function mounted() {
    $(".engin-content img").each(function (index, val) {

      // if (this.naturalWidth > this.naturalHeight) {
      //   this.setAttribute('id', 'wide')
      // } else if (this.naturalWidth > this.naturalHeight) {
      //   this.setAttribute('id', 'narrow')
      // }
      if (this.width > this.height) {
        this.setAttribute("id", "wide");
      } else {
        this.setAttribute("id", "narrow");
      }
      val.onload = function () {
        if (this.width > this.height) {
          this.setAttribute("id", "wide");
        } else {
          this.setAttribute("id", "narrow");
        }
      };
    });
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/data/wwwroot/dongliyuanlin.com/web/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/engin/index.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/data/wwwroot/dongliyuanlin.com/web/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/engin/index.vue
// module chunks = 13